import { render, staticRenderFns } from "./SimpleIWRenderer.vue?vue&type=template&id=221ba904&scoped=true&"
import script from "./SimpleIWRenderer.vue?vue&type=script&lang=js&"
export * from "./SimpleIWRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SimpleIWRenderer.vue?vue&type=style&index=0&id=221ba904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ba904",
  null
  
)

export default component.exports